import { css, styled } from "goober";
import { mobile, tabletMedium } from "clutch/src/Style/style.mjs";

export const Footer = styled("footer")<{ $lift?: boolean }>`
  align-self: stretch;

  ${({ $lift }) => ($lift ? `margin-bottom: calc(var(--page-end) * -1);` : "")}

  background: var(--shade8);

  isolation: isolate;
`;

export const FooterContent = styled("div")<{ $expanded?: boolean }>`
  display: grid;
  grid-template:
    "info info company socials games"
    "copy copy language terms privacy";
  grid-template-columns: repeat(5, minmax(0, 1fr));
  row-gap: var(--sp-16);
  column-gap: var(--sp-2_5);

  max-width: ${({ $expanded }) =>
    $expanded ? "1200px" : "var(--sp-container)"};
  margin: 0 auto;
  padding: var(--sp-16) 0;

  ${tabletMedium} {
    grid-template:
      "info info info"
      "games games games"
      "company company company"
      "socials socials socials"
      "language terms privacy"
      "copy copy copy";
    row-gap: 0;

    padding: 0;
  }

  ${mobile} {
    grid-template:
      "info"
      "games"
      "company"
      "socials"
      "language"
      "terms"
      "privacy"
      "copy";
  }
`;

export const FooterInfo = styled("div")`
  grid-area: info;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--sp-3);

  min-height: var(--sp-46);

  ${tabletMedium} {
    flex-direction: row;

    min-height: auto;
    padding: var(--sp-8);
  }

  ${mobile} {
    flex-direction: column;

    min-height: auto;
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  align-items: center;

  ${mobile} {
    justify-content: center;
  }
`;

export const ButtonContainer = styled("div")`
  display: flex;

  ${mobile} {
    justify-content: center;
  }

  & > div {
    display: inline-flex;
    flex-direction: column;
    gap: var(--sp-6);

    & > * {
      justify-content: flex-start;
    }

    ${tabletMedium} {
      flex-direction: row;
    }

    ${mobile} {
      display: flex;
      flex-direction: column;

      & > * {
        justify-content: center;
      }
    }
  }

  .compliance-block {
    opacity: 0.75;
    display: flex;
    flex-direction: column;

    p {
      margin-bottom: var(--sp-3);
      ${tabletMedium} {
        text-align: center;
      }
    }

    ul {
      display: flex;
      justify-content: center;
      gap: var(--sp-4);

      li svg {
        width: auto;
        max-width: var(--sp-16);
        height: var(--sp-9);
      }
    }
  }
`;

export const cssDownloadButton = () => css`
  &:hover {
    background: linear-gradient(
        272.13deg,
        rgba(206, 15, 80, 0.5) 0%,
        rgba(254, 17, 45, 0.5) 100%
      ),
      var(--primary-hover) !important;

    transform: scale(1.05);
  }
`;

export const LinkGroup = styled("section")<{ $area: string }>`
  grid-area: ${(props) => props.$area};

  div {
    transition: background-color 0.5s;
  }

  .indicator {
    display: none;

    transition: transform 0.25s;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-bottom: var(--sp-4);

    color: var(--shade1);

    font-weight: 500;
    font-size: var(--sp-2_5e);
    letter-spacing: 1.5px;
    text-transform: uppercase;

    ${mobile} {
      cursor: pointer;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: var(--sp-1);

    transition: max-height 0.5s;

    li {
      color: var(--shade3);
    }

    a {
      color: var(--shade0);
    }

    a:hover {
      color: var(--shade1);
    }
  }

  ${tabletMedium} {
    .indicator {
      display: block;
    }

    .title {
      margin: 0;
      padding: var(--sp-4) var(--sp-8);

      color: var(--shade0);

      font-weight: 700;
      font-size: var(--sp-4e);
      letter-spacing: -0.009em;
      text-transform: none;
    }

    ul {
      gap: 0;

      max-height: 0;

      overflow: hidden;

      li {
        padding: var(--sp-4) var(--sp-8);
        padding-top: 0;
      }

      a {
        color: var(--shade1);
      }

      a:hover {
        color: var(--shade2);
      }
    }

    input:checked + div {
      background-color: var(--shade6);

      .indicator {
        transform: rotate(180deg);
      }

      ul {
        max-height: 20em;
      }
    }
  }
`;

export const FooterSub = styled("div")<{
  $area: "copy" | "language" | "terms" | "privacy";
}>`
  grid-area: ${(props) => props.$area};

  color: var(--shade1);

  font-weight: 600;
  font-size: 12px;
  line-height: 20px;

  a:hover {
    color: var(--shade2);
  }

  ${tabletMedium} {
    padding: var(--sp-4) var(--sp-8);
  }
`;
